import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAccountValue, getLastDividend } from '../../services/PortfolioApi/portfolioApi';
import { toastNotify } from '../../utils/toastNotify';
const initialState = {
  loading: true,
  accountValue: {},
  lastDividendData: {},
  isUpdating: false,
};
export const fetchAccountValueDataAction = createAsyncThunk('FEATCH_ACCOUNT_VALUE_DATA', getAccountValue);
export const featchLastDividendAction = createAsyncThunk('FEATCH_LAST_DIVIDEND_DATA', getLastDividend);

export const portfolioSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  extraReducers: {
    [fetchAccountValueDataAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchAccountValueDataAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        accountValue: action.payload,
      };
    },
    [fetchAccountValueDataAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        accountValue: {},
      };
    },

    [featchLastDividendAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [featchLastDividendAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        lastDividendData: action.payload,
      };
    },
    [featchLastDividendAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        lastDividendData: {},
      };
    },

  },
});

const { reducer } = portfolioSlice;
export default reducer;
